import { cn } from "@components/ui/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("tw:animate-pulse tw:rounded-md tw:bg-accent", className)}
      {...props}
    />
  )
}

export { Skeleton }
